import { smb_fetch, getAgpAgmsApiUrl } from '@/api/operator/fetch';

export const getContractSummary = () => {
  const url = getAgpAgmsApiUrl('agency_contract', 'summary');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data: {},
  }, false, false);
};

export const getContractList = (data: any) => {
  const url = getAgpAgmsApiUrl('agency_contract', 'list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    ...data,
  }, true, false);
};

export const getContractQRcode = (data: any) => {
  const url = getAgpAgmsApiUrl('agency_contract/econtract', 'get_sign_url');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '获取签署链接中，请稍后',
    data,
  }, true, false);
};

export const downloadContract = (data: any) => {
  const url = getAgpAgmsApiUrl('agency_contract/econtract', 'download_contract');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '文件下载中，请稍后',
    data,
  }, true, false);
};
